import React, { Component } from 'react';
import PropTypes from 'prop-types';
import GeneratePixelsButton from './GeneratePixelsButton';
import GenerateTagsButton from './GenerateTagsButton';
import './ExportButton.css';

class ExportButton extends Component {
  constructor(props) {
    super(props);
    this.hideModal = this.hideModal.bind(this);
    this.showModal = this.showModal.bind(this);
    this.state = { modalOpen: false };
  }

  showModal() {
    this.setState({ modalOpen: true });
  }

  hideModal() {
    this.setState({ modalOpen: false });
  }

  render() {
    const creative = this.props.CreativeService.getCreative();

    if (this.props.rtbVersion === '2.3') {
      return (
        <GeneratePixelsButton
          getCreatives={this.props.getCreatives}
          hideModal={this.hideModal}
          modalOpen={this.state.modalOpen}
          showModal={this.showModal}
        />
      );
    } else if (creative.action !== 'scroller') {
      return (
        <GenerateTagsButton
          AdMarkupService={this.props.AdMarkupService}
          FlashService={this.props.FlashService}
          getCreatives={this.props.getCreatives}
          hideModal={this.hideModal}
          modalOpen={this.state.modalOpen}
          showModal={this.showModal}
        />
      );
    }

    return null;
  }
}

ExportButton.propTypes = {
  getCreatives: PropTypes.func.isRequired,
  rtbVersion: PropTypes.string.isRequired,
  AdMarkupService: PropTypes.object.isRequired,
  FlashService: PropTypes.object.isRequired,
  CreativeService: PropTypes.shape({ getCreative: PropTypes.func.isRequired })
    .isRequired
};

export default ExportButton;
